import React from 'react';
export const FeaturedInSection = () => {
  return;
};